import { render, staticRenderFns } from "./RodapeMedico.vue?vue&type=template&id=372beb52&"
import script from "./RodapeMedico.vue?vue&type=script&lang=js&"
export * from "./RodapeMedico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports